import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { ChevronDown, ChevronRight, GripVertical } from "react-bootstrap-icons";
import "./sectionCard.css";

const SectionCard = ({ section, onCollapseToggle, readOnly = false }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: section.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const handleToggle = () => {
    onCollapseToggle(section.id);
  };

  const hasSubsections = section.subsections && section.subsections.length > 0;
  const isCollapsed = section.collapsed || false;

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      className={`section-card section-card-base ${
        isDragging ? "dragging" : ""
      }`}
    >
      <div
        className={`section-header section-header-base ${
          isCollapsed ? "collapsed" : ""
        }`}
        onClick={hasSubsections ? handleToggle : undefined}
        style={{ cursor: hasSubsections ? "pointer" : "default" }}
      >
        {!readOnly && (
          <div className="drag-handle" {...listeners}>
            <GripVertical size={16} className="text-muted" />
          </div>
        )}

        {hasSubsections && (
          <div className="collapse-toggle">
            {isCollapsed ? (
              <ChevronRight size={16} />
            ) : (
              <ChevronDown size={16} />
            )}
          </div>
        )}

        <div className="section-title">
          <span className="section-name">{section.name}</span>
          <div className="section-actions-placeholder"></div>
        </div>
      </div>

      {hasSubsections && !isCollapsed && (
        <div className="subsections-container">
          {section.subsections.map((subsection) => (
            <div
              key={subsection.id}
              className="subsection-item subsection-item-base"
            >
              <div className="subsection-content">
                <span className="subsection-name">{subsection.name}</span>
                <div className="subsection-actions-placeholder"></div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SectionCard;
